module.exports = __webpack_public_path__ + "static/media/esconder_icon.e2c60362.svg";